module.exports = __webpack_public_path__ + "assets/images/181f67152537f11d853de2a7fdc0b234.svg";